// JsFromRoutes CacheKey 6fd4ff78707a066b732a0cff70c6707f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  groupedByCategory: /* #__PURE__ */ definePathHelper(
    "get",
    "/api/:venue_slug/line_items/grouped_by_category"
  ),
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/line_items"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/line_items"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/line_items/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/line_items/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/line_items/:id"),
}
